import React, { useRef, useState } from 'react'
import ReactQuill from 'react-quill'
import 'react-quill/dist/quill.snow.css'

import Box from '@components/kit/box'

import './fax-quill.css'

type FaxQuillProps = {
  faxContent: string
  setFaxContent: (content: string) => void
}

function FaxQuill({ faxContent, setFaxContent }: FaxQuillProps) {
  const quillRef = useRef(null) // Referência para a barra de ferramentas
  const [isQuillFocused, setIsQuillFocused] = useState(false)

  const modules = {
    toolbar: [
      [{ color: [] }, { font: [] }],
      [[{ header: [1, 2, 3, 4, 5, 6, false] }]],
      ['bold', 'italic', 'underline', 'strike', 'blockquote'],
      [
        { list: 'ordered' },
        { list: 'bullet' },
        { indent: '-1' },
        { indent: '+1' }
      ],
      ['link', 'image'],
      ['clean']
    ]
  }

  const formats = [
    'color',
    'font',
    'header',
    'bold',
    'italic',
    'underline',
    'strike',
    'blockquote',
    'list',
    'bullet',
    'indent',
    'link',
    'image'
  ]

  const quillLayoutHandler = () => {
    const toolbarElement = document.querySelector('.ql-toolbar')
    if (toolbarElement && (toolbarElement as HTMLElement)?.offsetHeight) {
      document.documentElement.style.setProperty(
        '--react-quill-toolbar-height',
        (toolbarElement as HTMLElement).offsetHeight + 'px'
      ) // Define a variável CSS;
    }
  }

  // useEffect(() => {
  //   document.documentElement.style.setProperty(
  //     '--react-quill-toolbar-background-color',
  //     isQuillFocused ? '#F9FAFF' : '#F9FAFF'
  //   )
  // }, [isQuillFocused])

  return (
    <Box
      width='100%'
      minHeight='420px'
      maxHeight='600px'
      overflowX='hidden'
      overflowY='hidden'
      onLayout={quillLayoutHandler}
      borderRadius='small'
      borderWidth='2px'
      borderColor={isQuillFocused ? 'walrusBlue500' : 'walrusBlue100'}
      backgroundColor={
        isQuillFocused || faxContent.length > 0 ? 'white' : 'walrusBlue050'
      }
    >
      <ReactQuill
        theme='snow'
        className='quill-editor'
        value={faxContent}
        onChange={setFaxContent}
        onFocus={() => setIsQuillFocused(true)}
        onBlur={() => setIsQuillFocused(false)}
        style={{
          width: '100%',
          overflow: 'hidden'
        }}
        ref={quillRef}
        modules={modules}
        formats={formats}
      />
    </Box>
  )
}

export default FaxQuill
